import { Theme } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { themeColors } from '../../../styles/themeColors';
import { stylesConstants } from '../../../styles/stylesConstants';

export default makeStyles((theme: Theme) => ({
  container: {
    backgroundColor: themeColors.innerBackground,
    borderRadius: theme.spacing(0.5),
    border: stylesConstants.defaultBorder,
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    maxWidth: stylesConstants.inputFormWidth,
    height: 150,
  },
  uploadImage: {
    color: themeColors.iconPrimary,
    fontSize: '74px',
  },
}));
